import deliveryList from '@/Pages/ShippingPage/deliveryList';
export const outOfStockItems = [
  {
    id: deliveryList[0].productList[0].productId,
    name: deliveryList[0].productList[0].name,
    imageUrl: deliveryList[0].productList[0].imageUrl,
    storeName: deliveryList[0].productList[0].saleTagProps.storeName
  },
  {
    id: deliveryList[0].productList[1].productId,
    name: deliveryList[0].productList[1].name,
    imageUrl: deliveryList[0].productList[1].imageUrl,
    storeName: deliveryList[0].productList[1].saleTagProps.storeName
  },
  {
    id: deliveryList[0].productList[3].productId,
    name: deliveryList[0].productList[3].name,
    imageUrl: deliveryList[0].productList[3].imageUrl,
    storeName: deliveryList[0].productList[3].saleTagProps.storeName
  }
];
